export const debounce = (function_: (event: string) => void, timeout = 300) => {
  let timer: NodeJS.Timeout;
  const debounced = (...args: any) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      // @ts-ignore not about to wrestle with TS so I can use `this`
      function_.apply(this, args);
    }, timeout);
  };
  debounced.cancel = () => clearTimeout(timer);
  return debounced;
};
